import Event from '@oppobrowser/lib-browser-event';
import { fromSmallRedBook } from '../../js/constants';
import { humanize } from '../../js/utils';
import template from './index.dot';
import './index.scss';
import wv from '@cpc/lib-browser-jsapi';

const EventHandler = {};

// 特殊的小红书样式适配
const specialSmallredbookStyleMap = {
  "huchengxinxijishushanghaiyouxiangongsi": 1
};

export default class Meta {
  constructor(el, name, data = {}) {
    this.el = el;

    this._eventHandler = {};
  }

  init() {
    Object.keys(EventHandler).forEach((fn) => {
      this._eventHandler[fn] = EventHandler[fn].bind(this);
    });
    this._bindEvent();
  }

  _bindEvent() {
    this._comEvent = new Event('click', this.el);
    this._comEvent.registeHandler(this._eventHandler);
  }

  sourceName(vendor) {
    switch (vendor) {
      case 'ZAKER':
        return 'ZAKER新闻';
      case '开放平台':
        return 'OPPO开放平台';
      default:
        return window.store.source;
    }
  }

  getSourceName(vendor) {
    if (fromSmallRedBook) {
      const publishTime = window.pageData?.DOCINFO?.publishTime;
      if (specialSmallredbookStyleMap[vendor]) {
        return `内容来自于&nbsp;${this.sourceName(vendor)}`;
      }
      return `内容来自于&nbsp;小红书${
        publishTime
          ? `<span class="document-media__gap">·</span>${humanize(
              publishTime,
            )}发布`
          : ''
      }`;
    }
    return `内容来自于&nbsp;${this.sourceName(vendor)}`;
  }
  getClassName(vendor){
    if (fromSmallRedBook) {
      if (specialSmallredbookStyleMap[vendor]) {
        return `icon-source-${vendor}`
      }
      return `icon-source-smallredbook`
    }
    return `icon-source-${vendor}`;
  }
  render() {
    const { vendor } = window.store;
    this.el.innerHTML = template({
      className: this.getClassName(vendor),
      sourceName: this.getSourceName(vendor),
      showClass: !window.store.isShowFold.isShow ? '' : 'showClass',
    });
  }
}
